import { useState, useEffect } from "react";
//--------------------------------------------------------------------------------------------
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Context from "@ckeditor/ckeditor5-core/src/context";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import Esign from "src/components/common/esign";
import { useMyStore } from "src/components/main/mainStore";
import {
    arrayReducer, objAscSort, MyFormData, myAxios, MyDate,
    defaultEmptyDateTime, defaultEmptyDate,
    getJsonArray, timepicker
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function JobTag({
    closeIt,
    history,
    workLogs,
    setWorkLogs,
    admin,
    /*---- workLog ------------------------------------------------*/
    labor,
    laborFolderId,
    workInstructionHashKey,
    projectHashKey,
    projectName,
    jobTag,
    defaultSignId,
    contactEmail,
    contactName,
    userName,
    preDriver,
    postDriver,
    isFinished,
    clientPONumber,
    projectNumber,
    projectManager,
    clientProjectNumber,
    workPerformed,
    organizationName,
    additionalInfo,
    travelStartTime,
    travelEndTime,
    hadLunch,
    lunchStartTime,
    lunchEndTime,
    lunchReason,
    workStartTime,
    workEndTime,
    location,
    supervisor,
    supervisorEmail,
    supervisorPhone,
    workInstructionDescription,
    startTime,
    endTime,
    category,
    accurateTime,
    clientSignatureRequired,
    sendToClient,
    workLogHashKey,
    clientSupervisorName,
    laborCategory,
    coords,
    fieldSupervisorEmail,
    fieldSupervisorName,
    locationType: propsLocationType,
    yardReason: propsYardReason,
    startLocation: propsStartLocation
    /*-------------------------------------------------------------*/
}) {
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    // workLog: jobSafetyAnalysisContent, teamLead, labor, laborCategory, jobSafetyAnalysisTemplate, folderId, attachmentFolderId,
    // projectName, startTime, endTime, jobSafetyAnalysisTemplateDoc, workLogHashKey, laborFolderId, workInstructionHashKey, 
    // jobSafetyAnalysisSignId, jobSafetyAnalysisSignsId, location, teamLeadName, userName
    const [picData, setPicData] = useState([]);
    const [picData2, setPicData2] = useState([]);
    const [curCoords, setCoords] = useState(coords || "");
    const [startLocation, setStartLocation] = useState(propsStartLocation || "");
    const [yardReason, setYardReason] = useState(propsYardReason || "");
    const [hadLunchState, setHadLunchState] = useState(hadLunch || "");
    const [lunchStartTimeState, setLunchStartTimeState] = useState(() => {
        // If lunchStartTime is a datetime string like "2025-06-30 14:30", extract just the time
        if (lunchStartTime && lunchStartTime.includes(' ')) {
            return lunchStartTime.split(' ')[1] || "";
        }
        return lunchStartTime || "";
    });
    const [lunchEndTimeState, setLunchEndTimeState] = useState(() => {
        // If lunchEndTime is a datetime string like "2025-06-30 15:00", extract just the time
        if (lunchEndTime && lunchEndTime.includes(' ')) {
            return lunchEndTime.split(' ')[1] || "";
        }
        return lunchEndTime || "";
    });
    const [lunchReasonState, setLunchReasonState] = useState(lunchReason || "");
    const mainData = (workLogs.filter(workLog =>
        workLog.workLogVoid !== "yes" &&
        workLog.labor === labor &&
        workLog.jobTagSubmitTime !== defaultEmptyDateTime &&
        workLog.workLogHashKey !== workLogHashKey && (
            workLog.startTime.substring(0, 10) === startTime.substring(0, 10) ||
            workLog.endTime.substring(0, 10) === startTime.substring(0, 10) ||
            workLog.startTime.substring(0, 10) === endTime.substring(0, 10) ||
            workLog.endTime.substring(0, 10) === endTime.substring(0, 10)
        )
    )).map(workLog => [
        {
            ...workLog,
            time: workLog.travelStartTime.replace(/-/g, "/")
        },
        {
            ...workLog,
            time: workLog.travelEndTime.replace(/-/g, "/")
        }
    ]).reduce(arrayReducer, []).sort((a, b) => objAscSort(a, b, "time"));
    //--------------------------------------------------------------------------------------------
    const handleJobTagSave = async e => {
        const formData = new MyFormData(e);
        if (laborCategory === "Travel") {
            formData.append("workStartDate", formData.get("travelStartDate"));
            formData.append("workStartTime", formData.get("travelStartTime"));
            formData.append("workEndDate", formData.get("travelStartDate"));
            formData.append("workEndTime", formData.get("travelStartTime"));
        }
        formData.append("laborFolderId", laborFolderId);
        formData.append("sign", JSON.stringify(picData));
        formData.append("sign2", JSON.stringify(picData2));
        formData.append("workLogHashKey", workLogHashKey);
        formData.append("startLocation", startLocation);
        if (startLocation === "Yard") {
            formData.append("yardReason", yardReason);
        }
        // Add lunch data to save
        const lunchSaveValue = formData.get("hadLunch");
        if (lunchSaveValue === "Yes") {
            formData.append("lunchStartTime", formData.get("lunchStartTime"));
            formData.append("lunchEndTime", formData.get("lunchEndTime"));
            formData.append("lunchStartDate", formData.get("lunchStartDate"));
            formData.append("lunchEndDate", formData.get("lunchEndDate"));
        } else if (lunchSaveValue === "No") {
            formData.append("lunchReason", formData.get("lunchReason"));
        }
        if (admin) {
            formData.append("userEmail", labor);
        }
        formData.append("action", "Save");
        //---------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workLogs/jT.php", formData);
        setShowLoader(false);
        if (!res) return;
        //---------------------------------------------------
        const isFinished = formData.get("isFinished") === "NULL" ? null : formData.get("isFinished");
        const target = res.data
            .map(w => ({
                ...w,
                workInstructionFiles: JSON.parse(w.workInstructionFiles),
                workLogFiles: getJsonArray(w.workLogFiles),
                isFinished: isFinished,
                locationType: startLocation,
                yardReason: yardReason,
                lunchStartTime: w.lunchStart,
                lunchEndTime: w.lunchEnd,
                lunchReason: w.noLunchReason
            }))
            .find(w => w.workLogHashKey === workLogHashKey);
        setWorkLogs(workLogs.map(w => (w.workLogHashKey === workLogHashKey ?
            { ...w, ...target }
            : w)));
        history.push(
            admin ?
                `${admin}/${workLogHashKey}`
                :
                `/WorkLogs/${workLogHashKey}`
        );
    }
    const handleJobTagSubmit = async e => {
        e.preventDefault();
        if (!picData.length && category !== "GPR Concrete Scanning and Coring Project") {
            window.alert("Please Sign.");
            return;
        }
        if (!picData2.length && (clientSignatureRequired === "on" || category === "GPR Concrete Scanning and Coring Project")) {
            window.alert("Client signature required.");
            return;
        }
        if (!startLocation) {
            window.alert("Please select a Start Location (Residence or Yard).");
            return;
        }
        if (startLocation === "Yard") {
            if (!yardReason.trim()) {
                window.alert("Please provide a reason for starting at Yard.");
                return;
            }
            const sentences = yardReason.trim().split(/[.!?]+/).filter(s => s.trim());
            if (sentences.length > 3) {
                window.alert("Yard reason must not exceed 3 sentences.");
                return;
            }
        }
        // Lunch validation using state values
        if (hadLunchState === "Yes") {
            if (!lunchStartTimeState || !lunchEndTimeState) {
                window.alert("Please provide both lunch start and end times when selecting 'Yes' for had lunch.");
                return;
            }
        } else if (hadLunchState === "No") {
            if (!lunchReasonState || !lunchReasonState.trim()) {
                window.alert("Please provide a reason for not having lunch.");
                return;
            }
        }
        const formToSubmit = e.currentTarget;
        const formData = new MyFormData(formToSubmit);
        
        // Additional lunch time validation after formData is created
        if (hadLunchState === "Yes") {
            // Validate lunch times are in correct order
            const lunchStart = Date.parse(formData.get("lunchStartDate") + " " + formData.get("lunchStartTime"));
            const lunchEnd = Date.parse(formData.get("lunchEndDate") + " " + formData.get("lunchEndTime"));
            if (lunchStart >= lunchEnd) {
                window.alert("Lunch start time must be before lunch end time.");
                return;
            }
        }
        let ts, ws, we, te, travelStart, workStart, workEnd, travelEnd;
        if (laborCategory === "Travel") {
            formData.append("workStartDate", formData.get("travelStartDate"));
            formData.append("workStartTime", formData.get("travelStartTime"));
            formData.append("workEndDate", formData.get("travelStartDate"));
            formData.append("workEndTime", formData.get("travelStartTime"));
            ts = (formData.get("travelStartDate")).replace(/-/g, "/");
            ws = (formData.get("travelStartDate")).replace(/-/g, "/");
            we = (formData.get("travelStartDate")).replace(/-/g, "/");
            te = (formData.get("travelEndDate")).replace(/-/g, "/");
            travelStart = Date.parse(ts + " " + formData.get("travelStartTime"));
            workStart = Date.parse(ws + " " + formData.get("travelStartTime"));
            workEnd = Date.parse(we + " " + formData.get("travelStartTime"));
            travelEnd = Date.parse(te + " " + formData.get("travelEndTime"));
        } else {
            ts = (formData.get("travelStartDate")).replace(/-/g, "/");
            ws = (formData.get("workStartDate")).replace(/-/g, "/");
            we = (formData.get("workEndDate")).replace(/-/g, "/");
            te = (formData.get("travelEndDate")).replace(/-/g, "/");
            travelStart = Date.parse(ts + " " + formData.get("travelStartTime"));
            workStart = Date.parse(ws + " " + formData.get("workStartTime"));
            workEnd = Date.parse(we + " " + formData.get("workEndTime"));
            travelEnd = Date.parse(te + " " + formData.get("travelEndTime"));
        }
        const travel1 = (workStart - travelStart) / 3600000;
        const duration = (workEnd - workStart) / 3600000;
        const travel2 = (travelEnd - workEnd) / 3600000;
        if (travel1 >= 12) {
            if(!window.confirm(`Did your pre-work travel for ${travel1} hours?`)){
            // window.alert("Your travel start time should be PM.");
            return;
            }
        }
        if (duration >= 12) {
            if (!window.confirm(`Did you work for ${duration} hours?`)) {
                window.alert("Check your work start time and work end time AM/PM.");
                return;
            }
        }
        if (travel2 >= 12) {
            if(!window.confirm(`Did your post-work travel for ${travel2} hours?`)){
            // window.alert("Your travel end time should be AM.");
            return;
            }
        }
        if (travelStart > workStart) {
            window.alert("Travel start time is greater than work start time!");
            return;
        };
        if (workStart > workEnd) {
            window.alert("Work start time is greater than work end time!");
            return;
        };
        if (workEnd > travelEnd) {
            window.alert("Work end time is greater than travel end time!");
            return;
        };
        let msg;
        if (ts !== ws) {
            msg = "Travel start date is different from work start date.";
        } else if (ws !== we) {
            msg = "Work start date is different from work end date.";
        } else if (we !== te) {
            msg = "Work end date is different from travel end date.";
        }
        if (msg && !window.confirm("is this a night job?")) {
            window.alert(msg);
            return;
        }
        if (mainData) {
            let travelStarti, travelEndi;
            for (let i = 0; i < mainData.length; i++) {
                if (travelStart < (new Date(mainData[i].time))) {
                    travelStarti = i;
                    break;
                }
            }
            if (travelStarti === undefined) {
                travelStarti = mainData.length
            }
            for (let i = 0; i < mainData.length; i++) {
                if (travelEnd <= (new Date(mainData[i].time))) {
                    travelEndi = i;
                    break;
                }
            }
            if (travelEndi === undefined) {
                travelEndi = mainData.length
            }
            if (travelStarti === travelEndi) {
                if (travelStarti % 2) {
                    //old - within a duration:
                    const x = mainData[travelStarti];
                    window.alert(`Time conflict with ${x.projectName} ${x.travelStartTime.substring(0, 16)} ~ ${x.travelStartTime.substring(0, 10) !== x.travelEndTime.substring(0, 10) ? x.travelEndTime : x.travelEndTime.substring(11, 16)}`);
                    return;
                }
            } else {
                const arr = [];
                for (let i = travelStarti; i <= travelEndi; i++) {
                    if (i % 2) {
                        const x = mainData[i];
                        arr.push(`${x.projectName} ${x.travelStartTime.substring(0, 16)} ~ ${x.travelStartTime.substring(0, 10) !== x.travelEndTime.substring(0, 10) ? x.travelEndTime : x.travelEndTime.substring(11, 16)}`);
                    }
                }
                window.alert(`Time conflict with ${arr.join(", ")}`);
                return;
            }
        }
        formData.append("startLocation", startLocation);
        if (startLocation === "Yard") {
            formData.append("yardReason", yardReason);
        }
        // Add lunch data
        const lunchSubmitValue = formData.get("hadLunch");
        if (lunchSubmitValue === "Yes") {
            formData.append("lunchStartTime", formData.get("lunchStartTime"));
            formData.append("lunchEndTime", formData.get("lunchEndTime"));
            formData.append("lunchStartDate", formData.get("lunchStartDate"));
            formData.append("lunchEndDate", formData.get("lunchEndDate"));
        } else if (lunchSubmitValue === "No") {
            formData.append("lunchReason", formData.get("lunchReason"));
        }
        formData.append("workInstructionHashKey", workInstructionHashKey);
        formData.append("laborFolderId", laborFolderId);
        formData.append("clientSignatureRequired", clientSignatureRequired);
        formData.append("sendToClient", sendToClient);
        formData.append("supervisorEmail", supervisorEmail);
        formData.append("sign", JSON.stringify(picData));
        formData.append("sign2", JSON.stringify(picData2));
        formData.append("workLogHashKey", workLogHashKey);
        formData.append("projectHashKey", projectHashKey);
        formData.append("projectName", projectName);
        formData.append("clientPONumber", clientPONumber);
        //formData.append("requestorEmail", requestor.contactEmail);
        formData.append("requestor", contactName);
        formData.append("prevJobTag", jobTag);
        formData.append("user", userName || user.userName);
        formData.append("action", "Submit");
        const temp = document.createElement("div");
        temp.innerHTML = workInstructionDescription;
        formData.append("workRequestedText", temp.innerText);
        formData.append("workPerformedText", formData.get("workPerformed"));
        formData.append("additionalInfoText", formData.get("additionalInfo"));
        if (category !== "GPR Concrete Scanning and Coring Project") {
            formData.append("signUrl", document.getElementById("esigna").toDataURL());
        }
        if (category === "GPR Concrete Scanning and Coring Project" || clientSignatureRequired === "on") {
            formData.append("sign2Url", document.getElementById("esignb").toDataURL());
        }
        formData.append("form", "jobTag");
        formData.append("prevJobTag", jobTag);
        if (admin) {
            formData.append("userEmail", labor);
        }
        //---------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workLogs/jT.php", formData);
        setShowLoader(false);
        if (!res) return;
        //---------------------------------------------------
        const isFinished = formData.get("isFinished") === "NULL" ? null : formData.get("isFinished");
        const target = res.data[0];
        setWorkLogs(workLogs.map(w =>
            w.workLogHashKey === workLogHashKey ?
                {
                    ...w,
                    ...target,
                    workInstructionFiles: JSON.parse(target.workInstructionFiles),
                    workLogFiles: getJsonArray(target.workLogFiles),
                    isFinished,
                    locationType: startLocation,
                    yardReason: yardReason,
                    lunchStartTime: lunchStartTimeState,
                    lunchEndTime: lunchEndTimeState,
                    lunchReason: lunchReasonState
                }
                : w
        ));
        history.push(
            admin ?
                `${admin}/${workLogHashKey}`
                :
                `/WorkLogs/${workLogHashKey}`
        );
    }
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("workLogHashKey", workLogHashKey);
            formData.append("action", "Read");
            //---------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("workLogs/jT.php", formData);
            if (!isMounted) return;
            setShowLoader(false);
            if (!res) return;
            setPicData(JSON.parse(res.data.sign || "[]") || []);
            setPicData2(JSON.parse(res.data.sign2 || "[]") || []);
            setStartLocation(res.data.form?.startLocation || propsStartLocation || "");
            setYardReason(res.data.form?.yardReason || propsYardReason || "");
            
            // Handle lunch data from server response - data is nested under form
            if (res.data.form?.hadLunch) {
                setHadLunchState(res.data.form.hadLunch);
            }
            if (res.data.form?.lunchStart) {
                // Parse datetime string "2025-06-30 14:30" into time "14:30"
                const lunchStartTime = res.data.form.lunchStart.split(' ')[1] || "";
                setLunchStartTimeState(lunchStartTime);
            }
            if (res.data.form?.lunchEnd) {
                // Parse datetime string "2025-06-30 15:00" into time "15:00"
                const lunchEndTime = res.data.form.lunchEnd.split(' ')[1] || "";
                setLunchEndTimeState(lunchEndTime);
            }
            if (res.data.form?.noLunchReason) {
                setLunchReasonState(res.data.form.noLunchReason);
            }
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    }, [])
    //--------------------------------------------------------------------------------------------
    return (
        <Modal
            closeIt={closeIt}
            title="JOB TAG"
            width={1080}
            maxWidth={"100%"}
            handleFormSubmit={handleJobTagSubmit}
            actionKey="Submit"
            onSave={handleJobTagSave}
        >
            {user.jobTagLocation ?
                <div className="blk5 my-2" style={{ display: "flex", alignItems: "center" }}>
                    <span
                        className="btn btn-primary mr-3"
                        onClick={e => {
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition(pos => {
                                    setCoords(pos.coords.latitude + "," + pos.coords.longitude + "," + pos.coords.accuracy);
                                }, error => window.alert(error.message), { enableHighAccuracy: true, timeout: 15000 });
                            } else {
                                window.alert("The function is not supported.");
                                setCoords("");
                            }
                        }}
                    >Get location</span>
                    {curCoords ?
                        <a
                            href={`https://www.google.com/maps/search/${curCoords.split(",").slice(0, 2).join(",")}`} target="_blank" rel="noreferrer"
                        >
                            Coordinates: {curCoords.split(",").slice(0, 2).join(",")} Accuracy: {curCoords.split(",")[2]} meters
                        </a> : <></>}
                </div>
                : <></>}
            <input
                className="nodisplay" readOnly
                name="coords" value={curCoords}
            />
            <div className="blk5 my-2" style={{ display: "flex", alignItems: "center" }}>
                <label className="mr-3">Bess Project Manager</label>
                <input
                    type="text"
                    className="form-control mr-3"
                    style={{ flexGrow: 1 }}
                    name="projectManager" readOnly
                    value={projectManager}
                />
                <label className="mr-3">Bess Project Number</label>
                <input
                    type="text"
                    className="form-control"
                    style={{ flexGrow: 1 }}
                    name="projectNumber" readOnly
                    value={projectNumber}
                />
            </div>
            <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                <label className="mr-3">Client Name</label>
                <input
                    type="text"
                    className="form-control mr-3"
                    style={{ flexGrow: 1 }}
                    name="clientName" readOnly
                    value={organizationName}
                />
                <label className="mr-3">Client #</label>
                <input
                    type="text"
                    className="form-control mr-3"
                    style={{ flexGrow: 1 }}
                    name="clientProjectNumber" readOnly
                    value={clientProjectNumber}
                />
                <label className="mr-3">Client PO</label>
                <input
                    type="text"
                    className="form-control"
                    style={{ flexGrow: 1 }}
                    name="clientPONumber" readOnly
                    value={clientPONumber}
                />
            </div>
            <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                <label className="mr-3">Job Site</label>
                <input
                    type="text"
                    className="form-control"
                    style={{ flexGrow: 1 }}
                    name="jobSite" readOnly
                    value={location}
                />
            </div>
            <div className="blk5 mb-2" style={{ display: "flex" }}>
                {category === "GPR Concrete Scanning and Coring Project" ?
                    <>
                        <label className="mr-3">Supervisor Name</label>
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            name="fieldSupervisorName" readOnly
                            value={fieldSupervisorName || ""}
                        />
                        <label className="mr-3">Supervisor Email</label>
                        <input
                            type="text"
                            className="form-control"
                            style={{ flexGrow: 1 }}
                            name="fieldSupervisorEmail" readOnly
                            value={fieldSupervisorEmail || ""}
                        />
                    </>
                    :
                    <>
                        <label className="mr-3">Supervisor</label>
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            name="supervisor" readOnly
                            value={supervisor || ""}
                        />
                        <label className="mr-3">Supervisor Phone</label>
                        <input
                            type="text"
                            className="form-control"
                            style={{ flexGrow: 1 }}
                            name="supervisorPhone" readOnly
                            value={supervisorPhone || ""}
                        />
                    </>
                }
            </div>
            {category === "GPR Concrete Scanning and Coring Project" || clientSignatureRequired === "on" ?
                <div className="blk5 mb-2" style={{ display: "flex" }}>
                    <label className="mr-3">Requestor Name</label>
                    <input
                        type="text"
                        className="form-control mr-3"
                        style={{ flexGrow: 1 }}
                        name="requestorName" readOnly
                        value={contactName || ""}
                    />
                    <label className="mr-3">Requestor Email</label>
                    <input
                        type="text"
                        className="form-control"
                        style={{ flexGrow: 1 }}
                        name="requestorEmail" readOnly
                        value={contactEmail || ""}
                    />
                </div>
                : null}
            <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                <label className="mr-3">PreWork Driver:</label>
                <input
                    type="text"
                    className="form-control mr-3"
                    style={{ flexGrow: 1 }}
                    name="preWorkDriver" readOnly
                    value={preDriver}
                />
            </div>
            {laborCategory !== "Travel" ? <>
                <div className="blk5 mb-2" style={{ display: "flex" }}>
                    <label className="required-field mr-3"><strong>Travel Start Time</strong></label>
                    {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            readOnly
                            name="travelStartDate"
                            value={startTime.substring(0, 10)}
                        /> :
                        <select
                            className="form-control mr-3"
                            name="travelStartDate"
                            required
                            defaultValue={
                                workStartTime.substring(0, 10) !== defaultEmptyDate ?
                                    workStartTime.substring(0, 10) :
                                    startTime.substring(0, 10)
                            }
                        >
                            <option value="">Select</option>
                            <option>{startTime.substring(0, 10)}</option>
                            <option>{endTime.substring(0, 10)}</option>
                        </select>
                    }
                    {accurateTime !== "on" ?
                        <select
                            className="form-control mr-3"
                            name="travelStartTime"
                            required
                            defaultValue={
                                travelStartTime !== defaultEmptyDateTime ?
                                    travelStartTime.split(" ")[1].substring(0, 5) :
                                    startTime.substring(11, 16)}

                        >
                            <option value="">Select</option>
                            {timepicker().map((t, i) =>
                                <option key={i} value={t.value}>{t.text}</option>
                            )}
                        </select>
                        :
                        <input
                            type="time"
                            className="form-control mr-3"
                            required
                            name="travelStartTime"
                            defaultValue={
                                travelStartTime !== defaultEmptyDateTime ?
                                    travelStartTime.split(" ")[1].substring(0, 5) :
                                    startTime.substring(11, 16)
                            }
                        />
                    }
                    <label className="required-field mr-3"><strong>Work Start Time</strong></label>
                    {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            readOnly
                            name="workStartDate"
                            value={startTime.substring(0, 10)}
                        /> :
                        <select
                            className="form-control mr-3"
                            name="workStartDate"
                            required
                            defaultValue={
                                workStartTime.substring(0, 10) !== defaultEmptyDate ?
                                    workStartTime.substring(0, 10) :
                                    startTime.substring(0, 10)
                            }
                        >
                            <option value="">Select</option>
                            <option>{startTime.substring(0, 10)}</option>
                            <option>{endTime.substring(0, 10)}</option>
                        </select>
                    }
                    {accurateTime !== "on" ?
                        <select
                            className="form-control"
                            name="workStartTime"
                            required
                            defaultValue={
                                workStartTime !== defaultEmptyDateTime ?
                                    workStartTime.split(" ")[1].substring(0, 5) :
                                    startTime.substring(11, 16)
                            }
                        >
                            {timepicker().map((t, i) => <option key={i} value={t.value}>{t.text}</option>)}
                        </select>
                        :
                        <input
                            type="time"
                            className="form-control"
                            required
                            name="workStartTime"
                            defaultValue={
                                workStartTime !== defaultEmptyDateTime ?
                                    workStartTime.split(" ")[1].substring(0, 5) :
                                    startTime.substring(11, 16)
                            }
                        />
                    }
                </div>
                <div className="my-2">
                    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div className="required-field mr-3"><strong>Start Location:</strong></div>
                                <label htmlFor="startLocationResidence" className="mr-2">Residence</label>
                                <input
                                    type="radio"
                                    required={true}
                                    id="startLocationResidence"
                                    name="startLocation"
                                    checked={startLocation === "Residence"}
                                    onChange={e => setStartLocation("Residence")}
                                    value="Residence"
                                    className="mr-2"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        verticalAlign: "middle",
                                        flexShrink: 0
                                    }}
                                />
                                <label htmlFor="startLocationYard" className="mr-2">Yard</label>
                                <input
                                    type="radio"
                                    required={true}
                                    id="startLocationYard"
                                    name="startLocation"
                                    checked={startLocation === "Yard"}
                                    onChange={e => setStartLocation("Yard")}
                                    value="Yard"
                                    className="mr-2"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        verticalAlign: "middle",
                                        flexShrink: 0
                                    }}
                                />
                            </div>
                            {startLocation === "Yard" && (
                                <div>
                                    <div className="required-field mb-1"><strong>Yard Start Reason:</strong></div>
                                    <textarea
                                        name="yardReason"
                                        value={yardReason}
                                        onChange={e => setYardReason(e.target.value)}
                                        className="form-control"
                                        style={{
                                            width: "100%",
                                            height: "38px",
                                            resize: "none",
                                            overflowY: "hidden",
                                            overflowX: "auto",
                                            whiteSpace: "nowrap"
                                        }}
                                        rows={1}
                                        required
                                    />
                                </div>
                            )}
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="required-field mr-3"><strong>Had Lunch?</strong></div>
                            <label htmlFor="hadLunchYes" className="mr-2">Yes</label>
                            <input
                                type="radio"
                                required={true}
                                id="hadLunchYes"
                                name="hadLunch"
                                checked={hadLunchState === "Yes"}
                                onChange={e => setHadLunchState("Yes")}
                                value="Yes"
                                className="mr-2"
                                style={{
                                    width: 28,
                                    height: 28,
                                    verticalAlign: "middle",
                                    flexShrink: 0
                                }}
                            />
                            <label htmlFor="hadLunchNo" className="mr-2">No</label>
                            <input
                                type="radio"
                                required={true}
                                id="hadLunchNo"
                                name="hadLunch"
                                checked={hadLunchState === "No"}
                                onChange={e => setHadLunchState("No")}
                                value="No"
                                className="mr-2"
                                style={{
                                    width: 28,
                                    height: 28,
                                    verticalAlign: "middle",
                                    flexShrink: 0
                                }}
                            />
                        </div>
                        {hadLunchState === "Yes" && (
                            <div className="mt-2">
                                <div className="row">
                                    <div className="col-6">
                                        <div className="required-field mb-1"><strong>Lunch Start Time:</strong></div>
                                        <div style={{ display: "flex" }}>
                                            {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                                                <input
                                                    type="text"
                                                    className="form-control mr-3"
                                                    style={{ flexGrow: 1 }}
                                                    readOnly
                                                    name="lunchStartDate"
                                                    value={startTime.substring(0, 10)}
                                                /> :
                                                <select
                                                    className="form-control mr-3"
                                                    name="lunchStartDate"
                                                    required
                                                    defaultValue={startTime.substring(0, 10)}
                                                >
                                                    <option value="">Select</option>
                                                    <option>{startTime.substring(0, 10)}</option>
                                                    <option>{endTime.substring(0, 10)}</option>
                                                </select>
                                            }
                                            <input
                                                type="time"
                                                className="form-control"
                                                style={{ width: "170px" }}
                                                name="lunchStartTime"
                                                value={lunchStartTimeState}
                                                onChange={e => setLunchStartTimeState(e.target.value)}
                                                onClick={timepicker}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="required-field mb-1"><strong>Lunch End Time:</strong></div>
                                        <div style={{ display: "flex" }}>
                                            {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                                                <input
                                                    type="text"
                                                    className="form-control mr-3"
                                                    style={{ flexGrow: 1 }}
                                                    readOnly
                                                    name="lunchEndDate"
                                                    value={startTime.substring(0, 10)}
                                                /> :
                                                <select
                                                    className="form-control mr-3"
                                                    name="lunchEndDate"
                                                    required
                                                    defaultValue={startTime.substring(0, 10)}
                                                >
                                                    <option value="">Select</option>
                                                    <option>{startTime.substring(0, 10)}</option>
                                                    <option>{endTime.substring(0, 10)}</option>
                                                </select>
                                            }
                                            <input
                                                type="time"
                                                className="form-control"
                                                style={{ width: "170px" }}
                                                name="lunchEndTime"
                                                value={lunchEndTimeState}
                                                onChange={e => setLunchEndTimeState(e.target.value)}
                                                onClick={timepicker}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {hadLunchState === "No" && (
                            <div className="mt-2">
                                <div className="required-field mb-1"><strong>Reason for not having lunch:</strong></div>
                                <textarea
                                    name="lunchReason"
                                    value={lunchReasonState}
                                    onChange={e => setLunchReasonState(e.target.value)}
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        height: "38px",
                                        resize: "none",
                                        overflowY: "hidden",
                                        overflowX: "auto",
                                        whiteSpace: "nowrap"
                                    }}
                                    rows={1}
                                    required
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                    <label className="required-field mr-3"><strong>Work End Time</strong></label>
                    {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            readOnly
                            name="workEndDate"
                            value={endTime.substring(0, 10)}
                        /> :
                        <select
                            className="form-control mr-3"
                            name="workEndDate"
                            required
                            defaultValue={
                                workEndTime.substring(0, 10) !== defaultEmptyDate ?
                                    workEndTime.substring(0, 10) :
                                    endTime.substring(0, 10)
                            }
                        >
                            <option value="">Select</option>
                            <option>{endTime.substring(0, 10)}</option>
                            <option>{startTime.substring(0, 10)}</option>
                        </select>
                    }
                    {accurateTime !== "on" ?
                        <select
                            className="form-control mr-3"
                            required
                            name="workEndTime"
                            defaultValue={
                                workEndTime !== defaultEmptyDateTime ?
                                    workEndTime.split(" ")[1].substring(0, 5) :
                                    endTime.substring(11, 16)
                            }
                        >
                            {timepicker().map((t, i) => <option key={i} value={t.value}>{t.text}</option>)}
                        </select>
                        :
                        <input
                            type="time"
                            className="form-control mr-3"
                            name="workEndTime"
                            required
                            defaultValue={
                                workEndTime !== defaultEmptyDateTime ?
                                    workEndTime.split(" ")[1].substring(0, 5) :
                                    endTime.substring(11, 16)
                            }
                        />
                    }
                    <label className="required-field mr-3"><strong>Travel End Time</strong></label>
                    {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            readOnly
                            name="travelEndDate"
                            value={endTime.substring(0, 10)}
                        /> :
                        <select
                            className="form-control mr-3"
                            name="travelEndDate"
                            required
                            defaultValue={endTime.substring(0, 10)}
                        >
                            <option value="">Select</option>
                            <option>{endTime.substring(0, 10)}</option>
                            <option>{startTime.substring(0, 10)}</option>
                        </select>
                    }
                    {accurateTime !== "on" ?
                        <select
                            className="form-control"
                            name="travelEndTime"
                            required
                            defaultValue={
                                travelEndTime !== defaultEmptyDateTime ?
                                    travelEndTime.split(" ")[1].substring(0, 5) :
                                    endTime.substring(11, 16)
                            }
                        >
                            {timepicker().map((t, i) => <option key={i} value={t.value}>{t.text}</option>)}
                        </select>
                        :
                        <input
                            className="form-control"
                            type="time"
                            required
                            name="travelEndTime"
                            defaultValue={
                                travelEndTime !== defaultEmptyDateTime ?
                                    travelEndTime.split(" ")[1].substring(0, 5) :
                                    endTime.substring(11, 16)
                            }
                        />
                    }
                </div>
            </> :
                <>
                    <div className="blk5 mb-2" style={{ display: "flex" }}>
                        <label className="required-field mr-3"><strong>Travel Start Time</strong></label>
                        <input
                            type="text"
                            className="form-control mr-3"
                            style={{ flexGrow: 1 }}
                            readOnly
                            name="travelStartDate"
                            value={startTime.substring(0, 10)}
                        />
                        {accurateTime !== "on" ?
                            <select
                                className="form-control mr-3"
                                name="travelStartTime"
                                required
                                defaultValue={
                                    travelStartTime !== defaultEmptyDateTime ?
                                        travelStartTime.split(" ")[1].substring(0, 5) :
                                        startTime.substring(11, 16)
                                }
                            >
                                <option value="">Select</option>
                                {timepicker().map((t, i) =>
                                    <option key={i} value={t.value}>{t.text}</option>
                                )}
                            </select>
                            :
                            <input
                                type="time"
                                className="form-control mr-3"
                                required
                                name="travelStartTime"
                                defaultValue={
                                    travelStartTime !== defaultEmptyDateTime ?
                                        travelStartTime.split(" ")[1].substring(0, 5) :
                                        startTime.substring(11, 16)
                                }
                            />
                        }
                    </div>
                    <div className="my-2">
                        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div className="required-field mr-3"><strong>Start Location:</strong></div>
                                    <label htmlFor="startLocationResidence2" className="mr-2">Residence</label>
                                    <input
                                        type="radio"
                                        required={true}
                                        id="startLocationResidence2"
                                        name="startLocation2"
                                        checked={startLocation === "Residence"}
                                        onChange={e => setStartLocation("Residence")}
                                        value="Residence"
                                        className="mr-2"
                                        style={{
                                            width: 28,
                                            height: 28,
                                            verticalAlign: "middle",
                                            flexShrink: 0
                                        }}
                                    />
                                    <label htmlFor="startLocationYard2" className="mr-2">Yard</label>
                                    <input
                                        type="radio"
                                        required={true}
                                        id="startLocationYard2"
                                        name="startLocation2"
                                        checked={startLocation === "Yard"}
                                        onChange={e => setStartLocation("Yard")}
                                        value="Yard"
                                        className="mr-2"
                                        style={{
                                            width: 28,
                                            height: 28,
                                            verticalAlign: "middle",
                                            flexShrink: 0
                                        }}
                                    />
                                </div>
                                {startLocation === "Yard" && (
                                    <div>
                                        <div className="required-field mb-1"><strong>Yard Start Reason:</strong></div>
                                        <textarea
                                            name="yardReason"
                                            value={yardReason}
                                            onChange={e => setYardReason(e.target.value)}
                                            className="form-control"
                                            style={{
                                                width: "100%",
                                                height: "38px",
                                                resize: "none",
                                                overflowY: "hidden",
                                                overflowX: "auto",
                                                whiteSpace: "nowrap"
                                            }}
                                            rows={1}
                                            required
                                        />
                                    </div>
                                )}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div className="required-field mr-3"><strong>Had Lunch?</strong></div>
                                <label htmlFor="hadLunchYes2" className="mr-2">Yes</label>
                                <input
                                    type="radio"
                                    required={true}
                                    id="hadLunchYes2"
                                    name="hadLunch"
                                    checked={hadLunchState === "Yes"}
                                    onChange={e => setHadLunchState("Yes")}
                                    value="Yes"
                                    className="mr-2"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        verticalAlign: "middle",
                                        flexShrink: 0
                                    }}
                                />
                                <label htmlFor="hadLunchNo2" className="mr-2">No</label>
                                <input
                                    type="radio"
                                    required={true}
                                    id="hadLunchNo2"
                                    name="hadLunch"
                                    checked={hadLunchState === "No"}
                                    onChange={e => setHadLunchState("No")}
                                    value="No"
                                    className="mr-2"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        verticalAlign: "middle",
                                        flexShrink: 0
                                    }}
                                />
                            </div>
                            {hadLunchState === "Yes" && (
                                <div className="mt-2">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="required-field mb-1"><strong>Lunch Start Time:</strong></div>
                                            <div style={{ display: "flex" }}>
                                                {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                                                    <input
                                                        type="text"
                                                        className="form-control mr-3"
                                                        style={{ flexGrow: 1 }}
                                                        readOnly
                                                        name="lunchStartDate"
                                                        value={startTime.substring(0, 10)}
                                                    /> :
                                                    <select
                                                        className="form-control mr-3"
                                                        name="lunchStartDate"
                                                        required
                                                        defaultValue={startTime.substring(0, 10)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option>{startTime.substring(0, 10)}</option>
                                                        <option>{endTime.substring(0, 10)}</option>
                                                    </select>
                                                }
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    style={{ width: "170px" }}
                                                    name="lunchStartTime"
                                                    value={lunchStartTimeState}
                                                    onChange={e => setLunchStartTimeState(e.target.value)}
                                                    onClick={timepicker}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="required-field mb-1"><strong>Lunch End Time:</strong></div>
                                            <div style={{ display: "flex" }}>
                                                {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                                                    <input
                                                        type="text"
                                                        className="form-control mr-3"
                                                        style={{ flexGrow: 1 }}
                                                        readOnly
                                                        name="lunchEndDate"
                                                        value={startTime.substring(0, 10)}
                                                    /> :
                                                    <select
                                                        className="form-control mr-3"
                                                        name="lunchEndDate"
                                                        required
                                                        defaultValue={startTime.substring(0, 10)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option>{startTime.substring(0, 10)}</option>
                                                        <option>{endTime.substring(0, 10)}</option>
                                                    </select>
                                                }
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    style={{ width: "170px" }}
                                                    name="lunchEndTime"
                                                    value={lunchEndTimeState}
                                                    onChange={e => setLunchEndTimeState(e.target.value)}
                                                    onClick={timepicker}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {hadLunchState === "No" && (
                                <div className="mt-2">
                                    <div className="required-field mb-1"><strong>Reason for not having lunch:</strong></div>
                                    <textarea
                                        name="lunchReason"
                                        value={lunchReasonState}
                                        onChange={e => setLunchReasonState(e.target.value)}
                                        className="form-control"
                                        style={{
                                            width: "100%",
                                            height: "38px",
                                            resize: "none",
                                            overflowY: "hidden",
                                            overflowX: "auto",
                                            whiteSpace: "nowrap"
                                        }}
                                        rows={1}
                                        required
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="blk5 mb-2" style={{ display: "flex" }}>
                        <label className="required-field mr-3"><strong>Travel End Time</strong></label>
                        {startTime.substring(0, 10) === endTime.substring(0, 10) ?
                            <input
                                type="text"
                                className="form-control mr-3"
                                style={{ flexGrow: 1 }}
                                readOnly
                                name="travelEndDate"
                                value={endTime.substring(0, 10)}
                            /> :
                            <select
                                className="form-control mr-3"
                                name="travelEndDate"
                                required
                                defaultValue={endTime.substring(0, 10)}
                            >
                                <option value="">Select</option>
                                <option>{endTime.substring(0, 10)}</option>
                                <option>{startTime.substring(0, 10)}</option>
                            </select>
                        }
                        {accurateTime !== "on" ?
                            <select
                                className="form-control"
                                name="travelEndTime"
                                required
                                defaultValue={
                                    travelEndTime !== defaultEmptyDateTime ?
                                        travelEndTime.split(" ")[1].substring(0, 5) :
                                        endTime.substring(11, 16)
                                }
                            >
                                {timepicker().map((t, i) => <option key={i} value={t.value}>{t.text}</option>)}
                            </select>
                            :
                            <input
                                className="form-control"
                                type="time"
                                required
                                name="travelEndTime"
                                defaultValue={
                                    travelEndTime !== defaultEmptyDateTime ?
                                        travelEndTime.split(" ")[1].substring(0, 5) :
                                        endTime.substring(11, 16)
                                }
                            />
                        }
                    </div>
                </>
            }
            <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                <label className="mr-3">PostWork Driver:</label>
                <input
                    type="text"
                    className="form-control mr-3"
                    style={{ flexGrow: 1 }}
                    readOnly
                    name="postWorkDriver"
                    value={postDriver}
                />
            </div>
            <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                <div className="required-field mr-3"><strong>Work Finished?</strong></div>
                <label htmlFor="isFinishedYes" className="d-inline mr-2">Yes</label>
                <input
                    type="radio"
                    required={true}
                    id="isFinishedYes"
                    name="isFinished"
                    defaultChecked={isFinished === "1"}
                    value="1"
                    className="mr-2"
                    style={{
                        width: 28,
                        height: 28,
                        verticalAlign: "middle",
                        flexShrink: 0
                    }}
                />
                <label htmlFor="isFinishedNo" className="d-inline mr-2">No</label>
                <input
                    type="radio"
                    required={true}
                    id="isFinishedNo"
                    name="isFinished"
                    defaultChecked={isFinished === "0"}
                    value="0"
                    className="mr-2"
                    style={{
                        width: 28,
                        height: 28,
                        verticalAlign: "middle",
                        flexShrink: 0
                    }}
                />
                <label htmlFor="isFinishedNull" className="d-inline mr-2">Unknown</label>
                <input
                    type="radio"
                    required={true}
                    id="isFinishedNull"
                    name="isFinished"
                    defaultChecked={isFinished === null}
                    value="NULL"
                    className="mr-2"
                    style={{
                        width: 28,
                        height: 28,
                        verticalAlign: "middle",
                        flexShrink: 0
                    }}
                />
            </div>
            <div className="mb-2">
                <h4>Description - Work Requested</h4>
                <div className="border rounded">
                    <CKEditor
                        editor={ClassicEditor}
                        onReady={e => {
                            if (e && e.sourceElement.nextElementSibling) {
                                e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                            }
                        }}
                        config={{
                            toolbar: []
                        }}
                        disabled={true}
                        data={workInstructionDescription}
                    />
                </div>
            </div>

            <div className="mb-2">
                <h4>Description - Work Performed</h4>
                <textarea
                    className="form-control"
                    style={{ width: "100%" }}
                    rows={5}
                    name="workPerformed"
                    defaultValue={workPerformed || ""}
                />
            </div>
            <div className="mb-2">
                <h4>Additional Information</h4>
                <textarea
                    className="form-control"
                    style={{ width: "100%" }}
                    rows={5}
                    name="additionalInfo"
                    defaultValue={additionalInfo || ""}
                />
            </div>
            <div>
                <div className="border rounded mb-2 p-3">
                    <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                        <label className="required-field mr-3">Technician:</label>
                        <input
                            type="text"
                            className="form-control mr-3"
                            readOnly
                            name="memberName"
                            value={userName || user.userName}
                        />
                        <label className="required-field mr-3">Date:</label>
                        <input
                            type="text"
                            className="form-control mr-3"
                            readOnly
                            name="submitDate" value={(new MyDate()).s()}
                        />
                    </div>
                    {category !== "GPR Concrete Scanning and Coring Project" ?
                        <Esign
                            buttonClassName="my-2"
                            id={"a"}
                            picData={picData}
                            setPicData={setPicData}
                            prefix={`Technician`}
                            defaultSignId={admin ? defaultSignId : user.defaultSignId}
                        />
                        : null}
                </div>
                {category === "GPR Concrete Scanning and Coring Project" || clientSignatureRequired === "on" ?
                    <div className="border rounded mb-2 p-3">
                        <div className="blk5 mb-2" style={{ display: "flex", alignItems: "center" }}>
                            <label className="required-field mr-3">Client Supervisor:</label>
                            <input
                                type="text"
                                className="form-control mr-3"
                                required
                                name="clientSupervisorName"
                                defaultValue={clientSupervisorName || contactName}
                            />
                            <label className="required-field mr-3">Date:</label>
                            <input
                                type="text"
                                className="form-control mr-3"
                                readOnly
                                value={(new MyDate()).s()}
                            />
                        </div>
                        <Esign
                            buttonClassName="my-2"
                            id={"b"}
                            picData={picData2}
                            setPicData={setPicData2}
                            prefix={`Client Supervisor`}
                            disableDefaultSign
                        />
                    </div> : null}
            </div>
        </Modal>
    )
}